// Mobile nav
const toggle = document.getElementById('mobile-toggle');
const drawer = document.getElementById('mobile-drawer');
const overlay = document.getElementById('drawer-overlay');

if (toggle && drawer && overlay) {
  function closeDrawer() {
    drawer.classList.remove('open');
    toggle.classList.remove('active');
    overlay.classList.remove('visible');
    document.body.classList.remove('drawer-open');
  }
  toggle.addEventListener('click', () => {
    const isOpen = drawer.classList.contains('open');
    if (isOpen) { closeDrawer(); }
    else {
      drawer.classList.add('open');
      toggle.classList.add('active');
      overlay.classList.add('visible');
      document.body.classList.add('drawer-open');
    }
  });
  overlay.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
}

// Nav shrink on scroll
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });
}

// Scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('is-visible');
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
document.querySelectorAll('.reveal-section').forEach(el => observer.observe(el));
